// LIBRARY
import React from 'react';
import PropTypes from 'prop-types';
import { Typography } from 'antd';
import Pager from 'shared_components/table_pager';

// CSS
import './table_header_right.css';

// CONSTANTS
const { Text } = Typography;


class SearchPagerRight extends React.Component {
	render() {
		const { pageSize, pageTotal } = this.props;
		
		const items = pageTotal > pageSize ? pageSize : pageTotal;

		return (
			<div className="table-title-right">
				<div>
					<div className="right" style={{marginTop: 10}}>
						<Text>{`Showing ${items} items out of ${pageTotal} lines`}</Text>
					</div>
				</div>
			</div>
		);
	}
}

SearchPagerRight.propTypes = {
	handleChangeSize: PropTypes.func.isRequired,
	pageTotal: PropTypes.number.isRequired,
	pageSize: PropTypes.number.isRequired
};

export default SearchPagerRight;
